module.exports = __webpack_public_path__ + "static/fonts/weathericons-regular-webfont.f5b0d0d.woff";


//////////////////
// WEBPACK FOOTER
// ./~/weather-icons/font/weathericons-regular-webfont.woff
// module id = 690
// module chunks = 1